(() => {
  if(window.FoDeliveryEstimate)return;
  const DAY=86400000,holidays=new Map();
  const key=date=>date.toISOString().slice(0,10);
  const addDays=(date,days)=>new Date(date.getTime()+days*DAY);
  const easter=year=>{
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4;
    const f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4;
    const l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451);
    const month=Math.floor((h+l-7*m+114)/31),day=(h+l-7*m+114)%31+1;
    return new Date(Date.UTC(year,month-1,day));
  };
  const holiday=date=>{
    const year=date.getUTCFullYear();
    if(!holidays.has(year)){
      const sunday=easter(year);
      holidays.set(year,new Set([
        year+'-01-01',year+'-05-01',year+'-10-03',year+'-12-25',year+'-12-26',
        ...[-2,1,39,50].map(offset=>key(addDays(sunday,offset)))
      ]));
    }
    return holidays.get(year).has(key(date));
  };
  const advance=(date,count,saturday)=>{
    let result=new Date(date);
    while(count>0){
      result=addDays(result,1);
      const day=result.getUTCDay();
      if(day!==0&&(saturday||day!==6)&&!holiday(result))count--;
    }
    return result;
  };
  const today=(now=new Date())=>{
    const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Berlin',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const get=type=>Number(parts.find(p=>p.type===type).value);
    return new Date(Date.UTC(get('year'),get('month')-1,get('day')));
  };
  // One preparation day (Mon–Fri), followed by 3–5 Hermes days (Mon–Sat).
  const estimate=(now=new Date())=>{
    const dispatch=advance(today(now),1,false);
    return {dispatch,earliest:advance(dispatch,3,true),latest:advance(dispatch,5,true)};
  };
  const formatRange=({earliest,latest})=>{
    const sameYear=earliest.getUTCFullYear()===latest.getUTCFullYear();
    if(sameYear&&earliest.getUTCMonth()===latest.getUTCMonth()){
      const month=new Intl.DateTimeFormat('de-DE',{month:'short',timeZone:'UTC'}).format(latest);
      return earliest.getUTCDate()+'.–'+latest.getUTCDate()+'. '+month;
    }
    const format=new Intl.DateTimeFormat('de-DE',{day:'numeric',month:'short',...(sameYear?{}:{year:'numeric'}),timeZone:'UTC'});
    return format.format(earliest)+' – '+format.format(latest);
  };
  window.FoDeliveryEstimate={estimate,formatRange};
  const settings=document.querySelector('[data-fo-delivery-settings]');
  if(!settings)return;
  const update=element=>{
    const current=key(today());
    if(element.dataset.deliveryDay===current)return;
    element.dataset.deliveryDay=current;
    const label=document.createElement('span');label.className='fo-delivery-label';label.textContent=(settings.dataset.label||'Voraussichtliche Lieferung').trim().replace(/:$/,'')+': ';
    const range=document.createElement('strong');range.className='fo-delivery-range';range.textContent=formatRange(estimate());
    element.replaceChildren(label,range);
  };
  const selector='[data-product-dispatch],[data-fo-preview-dispatch]';
  const scan=root=>{
    if(root.matches?.(selector))update(root);
    root.querySelectorAll?.(selector).forEach(update);
  };
  scan(document);
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node);}))).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)scan(document);});
  window.addEventListener('focus',()=>scan(document));
  document.addEventListener('shopify:section:load',()=>scan(document));
})();

